{
  "dropzones.clear_time": "Remove time only",
  "dropzones.clear_time_target": "Drop to remove the time only",
  "dropzones.defer_day": "Move to next day",
  "dropzones.defer_day_target": "Drop to move to the next day",
  "dropzones.unschedule": "Remove date",
  "dropzones.unschedule_target": "Drop to remove the date",
  "dropzones.schedule_updated": "Schedule updated",
  "dropzones.action_failed": "Could not update this task"
}
